import { render, staticRenderFns } from "./Workflow-Quoting.vue?vue&type=template&id=740dcb99&"
import script from "./Workflow-Quoting.vue?vue&type=script&lang=js&"
export * from "./Workflow-Quoting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports